/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ContractNoticeDetailsResponse } from './contractNoticeDetailsResponse';
import { ManagementBusinessEntityResponse } from './managementBusinessEntityResponse';
import { ManagementContractNoticeResponse } from './managementContractNoticeResponse';
import { ManagementMediumResponse } from './managementMediumResponse';
import { ManagementTagResponse } from './managementTagResponse';

export interface ManagementContractNoticeAndAnnouncementResponse { 
    id?: string;
    url?: string;
    fileUrl?: string;
    publishedDate?: Date;
    deliveryDate?: Date;
    contractNotice?: ManagementContractNoticeResponse;
    contractAuthority?: ManagementBusinessEntityResponse;
    details?: Array<ContractNoticeDetailsResponse>;
    contractors?: Array<ManagementBusinessEntityResponse>;
    procurementType?: ManagementContractNoticeAndAnnouncementResponse.ProcurementTypeEnum;
    divisiblePurchase?: boolean;
    estimatedPurchaseValue?: number;
    agreementValue?: number;
    currency?: ManagementContractNoticeAndAnnouncementResponse.CurrencyEnum;
    noticeType?: ManagementContractNoticeAndAnnouncementResponse.NoticeTypeEnum;
    announcementType?: ManagementContractNoticeAndAnnouncementResponse.AnnouncementTypeEnum;
    mediums?: Array<ManagementMediumResponse>;
    country?: ManagementContractNoticeAndAnnouncementResponse.CountryEnum;
    tags?: Array<ManagementTagResponse>;
    other?: { [key: string]: any; };
    createdFromAnnouncement?: boolean;
    autoTaggedMultipleCriteria?: boolean;
    autoTaggedSingleCriteria?: boolean;
    aiAutoTagged?: boolean;
    createdAt?: Date;
    eauction?: boolean;
    /** Hand-added (autotag UI, no live /api-docs yet). 1-4, null = manual/no signal. */
    color?: number;
    /** Hand-added (autotag UI, no live /api-docs yet). 0-1, higher = riskier, null = no signal. */
    riskScore?: number;
    /** Hand-added (autotag UI, no live /api-docs yet). */
    reviewed?: boolean;
}
export namespace ManagementContractNoticeAndAnnouncementResponse {
    export type ProcurementTypeEnum = 'GOODS' | 'SERVICES' | 'WORKS' | 'OTHER';
    export const ProcurementTypeEnum = {
        GOODS: 'GOODS' as ProcurementTypeEnum,
        SERVICES: 'SERVICES' as ProcurementTypeEnum,
        WORKS: 'WORKS' as ProcurementTypeEnum,
        OTHER: 'OTHER' as ProcurementTypeEnum
    };
    export type CurrencyEnum = 'MKD' | 'EUR' | 'USD' | 'ALL';
    export const CurrencyEnum = {
        MKD: 'MKD' as CurrencyEnum,
        EUR: 'EUR' as CurrencyEnum,
        USD: 'USD' as CurrencyEnum,
        ALL: 'ALL' as CurrencyEnum
    };
    export type NoticeTypeEnum = 'CONTRACT_NOTICE' | 'E_MARKET' | 'CONCESSION' | 'DEFENSE_AND_SECURITY_LAW' | 'SPECIAL_SERVICES' | 'TECHNICAL_DIALOGUES';
    export const NoticeTypeEnum = {
        CONTRACTNOTICE: 'CONTRACT_NOTICE' as NoticeTypeEnum,
        EMARKET: 'E_MARKET' as NoticeTypeEnum,
        CONCESSION: 'CONCESSION' as NoticeTypeEnum,
        DEFENSEANDSECURITYLAW: 'DEFENSE_AND_SECURITY_LAW' as NoticeTypeEnum,
        SPECIALSERVICES: 'SPECIAL_SERVICES' as NoticeTypeEnum,
        TECHNICALDIALOGUES: 'TECHNICAL_DIALOGUES' as NoticeTypeEnum
    };
    export type AnnouncementTypeEnum = 'CONTRACT_AWARD' | 'CANCELLATION' | 'MODIFICATION' | 'LATEST_DECISION';
    export const AnnouncementTypeEnum = {
        CONTRACTAWARD: 'CONTRACT_AWARD' as AnnouncementTypeEnum,
        CANCELLATION: 'CANCELLATION' as AnnouncementTypeEnum,
        MODIFICATION: 'MODIFICATION' as AnnouncementTypeEnum,
        LATESTDECISION: 'LATEST_DECISION' as AnnouncementTypeEnum
    };
    export type CountryEnum = 'MK' | 'AL' | 'XK';
    export const CountryEnum = {
        MK: 'MK' as CountryEnum,
        AL: 'AL' as CountryEnum,
        XK: 'XK' as CountryEnum
    };
}